// @ts-nocheck

import { Licences } from '../../../types/common';
import * as BannerAssets from '../assets/img/banners';

export const MPBannerBackgroundPathByLicences = {
  [Licences.FR]: BannerAssets.MPBannerFR,
  [Licences.ES]: BannerAssets.MPBannerES,
  [Licences.DE]: BannerAssets.MPBannerDE,
};
